import { render } from "./info.widget.wp.vue?vue&type=template&id=01d836c2"
import script from "./info.widget.wp.vue?vue&type=script&lang=js"
export * from "./info.widget.wp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__